import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { IAgendamentoDTO } from "../../../types/agendamento";
import { Agendamento } from "../../../services/Agendamento";
import { toast } from "react-toastify";
import { Itinerante } from "../../../services/Itinerante";
import {
  IItineranteDTO,
  IItineranteListProps,
} from "../../../types/itinerante";
import { useContextSite } from "../../../context/Context";
import { useMediaQuery } from "react-responsive";
import { IPagination } from "../../../types/pagination";
import { useForm, Controller } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";

const schema = z.object({
  cidade: z.string().min(1),
  dataInicio: z.string().optional().or(z.literal("")),
  dataFim: z.string().optional().or(z.literal("")),
});

export const useListItinerants = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [itinerantes, setItinerantes] = useState<IItineranteDTO[]>(
    [] as IItineranteDTO[]
  );
  const [agendamento, setAgendamento] = useState<IAgendamentoDTO>(
    {} as IAgendamentoDTO
  );
  const navigate = useNavigate();
  const { uuidAgendamento } = useParams();
  const { setIsLoad } = useContextSite();
  const isMobile = useMediaQuery({ maxWidth: "640px" });
  const [pagination, setPagination] = useState<IPagination>({} as IPagination);
  const [numberPage, setNumberPage] = useState(0);
  const [filter, setFilter] = useState<IItineranteListProps>(
    {} as IItineranteListProps
  );
  const { control, handleSubmit, resetField, setValue } =
    useForm<IItineranteListProps>({
      defaultValues: {
        cidade: "",
        dataInicio: "",
        dataFim: "",
      },
      resolver: zodResolver(schema),
    });

  function getAgenamento() {
    Agendamento.getById({ uuid: uuidAgendamento })
      .then(({ data }) => {
        setAgendamento(data);
      })
      .catch(
        ({
          response: {
            data: { messagem },
          },
        }) => toast.error(messagem)
      );
  }

  function getItinerantes(props?: IItineranteListProps) {
    setIsLoad(true);

    Itinerante.list({
      cidade: agendamento?.itinerante?.endereco?.cidade,
      ...props,
    })
      .then(({ data }) => {
        setItinerantes(data.content);
        setPagination({
          actualPage: data.number,
          totalPage: data.totalPages,
          totalRegister: data.totalElements,
        });
      })
      .catch(
        ({
          response: {
            data: { messagem },
          },
        }) => toast.error(messagem)
      )
      .finally(() => {
        setIsLoad(false);
      });
  }

  useEffect(() => {
    if (uuidAgendamento) {
      getAgenamento();
    }
  }, [uuidAgendamento]);

  useEffect(() => {
    if (agendamento?.uuid) {
      setValue("cidade", agendamento?.itinerante?.endereco?.cidade);
      getItinerantes();
    }
  }, [agendamento?.uuid]);

  useEffect(() => {
    if (!isOpen) {
      resetField("dataFim");
      resetField("dataInicio");
    }
  }, [isOpen]);

  function handleReset() {
    resetField("dataFim");
    resetField("dataInicio");
    getItinerantes({ page: 0 });
    setNumberPage(0);
  }

  useEffect(() => {
    if (agendamento?.uuid) {
      getItinerantes({ page: numberPage, ...filter });
    }
  }, [numberPage]);

  function submitFilter(props: IItineranteListProps) {
    getItinerantes({ page: 0, ...props });
    setFilter(props);
    setNumberPage(0);
  }

  return {
    isOpen,
    setIsOpen,
    itinerantes,
    isMobile,
    pagination,
    setNumberPage,
    control,
    handleSubmit,
    Controller,
    handleReset,
    submitFilter,
    uuidAgendamento,
    navigate,
  };
};
